<template>
  <div class="main-page wap">
    <Header></Header>
    <Banner></Banner>
    <Carousel></Carousel>
    <div class="m-wap-page top0 page-bottom">
      <Column></Column>
      <List></List>
    </div>
    <div
      v-if="extraItem.extras('copyright.display')"
      class="m-copyright"
      :style="{
        textAlign: extraItem.extras('copyright.position'),
        color: extraItem.extras('copyright.color'),
        fontSize:
          extraItem.extras('copyright.fontSize') === 'big'
            ? pxOrVw(28)
            : extraItem.extras('copyright.fontSize') === 'small'
            ? pxOrVw(20)
            : pxOrVw(24),
        fontWeight:
          extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
        fontStyle:
          extraItem.extras('copyright.italic') === 'italic'
            ? 'italic'
            : 'normal',
        whiteSpace: 'pre-line',
        paddingBottom: pxOrVw(30)
      }"
    >
      {{ extraItem.extras("copyright.model") }}
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../../components/Header";
import Column from "../../components/Wap/Column.vue";
//import Banner from "../../components/Banner.vue";
import List from "../../components/Wap/List.vue";
import Carousel from "../../components/Wap/Carousel.vue";
import { $subscriber } from "fire-wind-water";

import { articleCategoryId } from "../../common/sbase";
import Banner from "../../components/Banner.vue";
//  import $ from "jquery";

export default {
  name: "MoreColumn",
  data() {
    return {
      extras: {},
      page: {
        backgroundColor: {
          value: ""
        }
      }
    };
  },
  methods: {
    getCategory() {
      articleCategoryId;
    }
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
      this.page = res.page;
    });
  },
  components: {
    Banner,
    Header,
    Column,
    List,
    Carousel
  }
};
</script>
